<ngx-spinner type="ball-clip-rotate"></ngx-spinner>

<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-doctors-station-login></app-doctors-station-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-doctors-station-register></app-doctors-station-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-doctors-station-forgot-password></app-doctors-station-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-doctors-station-change-password-sent></app-doctors-station-change-password-sent>
  </div>

  <app-doctors-station-register-resend
    *ngIf="page === 'register-resend'"
  ></app-doctors-station-register-resend>
</ng-container>
